// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"251":"565b7aa6","573":"6cba0461","964":"565b7aa6"}[chunkId] + ".css";
};